import { IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { AiOutlineSetting } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

import DeleteTourModal from './delete-tour-modal';
import { styles } from './styles';

const TableMenu = ({ tourData }) => {
  const navigate = useNavigate();
  return (
    <Menu>
      <MenuButton as={IconButton} icon={<AiOutlineSetting />} sx={styles.menuBtn} />
      <MenuList>
        {/* eslint-disable-next-line no-underscore-dangle */}
        <MenuItem onClick={() => navigate(`edit/${tourData?._id}`)}>Редактировать</MenuItem>
        <DeleteTourModal tourData={tourData} />
      </MenuList>
    </Menu>
  );
};

export default TableMenu;
